import React, { Component } from "react";
import {
  Button,
  Modal,
  ModalFooter,
  ModalBody,
  Row,
  Col,
  Card,
  CardBody,
  TabContent,
  TabPane,
  FormGroup,
  Container,
} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Creatable from "react-select/creatable";
import awsLogo from "../../assets/images/aws_logo.png";
import azureLogo from "../../assets/images/azure_logo.png";
import { connect } from "react-redux";
import {
  updateOrgAccount,
  resetOrgAccountStatus,
  getListOfOrgsAndAccts,
  getAwsAcc,
} from "../../store/actions";
import {
  postAccountConfiguration,
  clearAllAccountConfigurationMessages,
} from "../../store/accountConfiguration/accountConfigurationSlice";
import { getAccountCloudType } from "../../CloudProviderContext";


import { withStyles } from "@material-ui/core/styles";
import { Snackbar } from "@mui/material";
import { Alert } from "@material-ui/lab";




const styles = (theme) => ({
  enabledTab: {
    // Add styles for enabled tab here
    color: theme.palette.primary.main,
  },
  disabledTab: {
    // Add styles for disabled tab here
    color: theme.palette.grey[400],
  },
});

export const getAddonsArray = (licenseData) => {
  console.log("licenseData in getAddonsArray", licenseData);
  let addonsArray = [];
  let addonsArrayTemp = [];
  if (licenseData) {
    addonsArrayTemp = licenseData.find(
      (licenseInfo) => licenseInfo.Name === "Basic"
    )["Add ons"];
    if (addonsArrayTemp) {
      addonsArray = addonsArrayTemp.map((addons) => ({
        name: addons.Name,
        enabled: false,
      }));
    }
  }

  return addonsArray;
};

class UpdateAccount extends React.PureComponent {
  static getStepInformation = (accountType = "AWS") => {
    const isAzure = accountType === "AZURE";
    const idLabel = isAzure ? "Subscription ID" : "Account Number";

    return {
      title: "Update Account Details",
      subtitle: isAzure
        ? "Review and update this Azure subscription's details."
        : "Review and update this AWS account's details.",
      steps: [
        `Confirm the organization and ${idLabel} shown. The ${idLabel} cannot be changed.`,
        "Update the Account Name if needed.",
        "Assign or change the Resource Group for this account.\n\nResource Group is an access group that connects this cloud account with the users permitted to view its data. If none is selected, the account will be assigned to the Default Resource Group.\n\nNote: A Resource Group can include multiple cloud accounts, but each account can belong to only one Resource Group.",
      ],
    };
  };

  constructor(props) {
    console.log("props.selectedAccount = ", props.selectedAccount);
    super(props);
    this.state = {
      breadcrumbItems: [
        { title: "Dashboard", link: "/dashboard" },
        { title: "Update an account", link: "#" },
      ],
      activeTab: 1,
      orgId: `${props.selectedAccount?.orgId}`,
      orgName: "",
      accountNumber: `${props.selectedAccount?.accountNumber}`,
      accountName: `${props.selectedAccount?.accountName}`,
      accountCode: `${props.selectedAccount?.accountCode}`,
      urlLink: `${props.selectedAccount?.urlLink}`,
      location: `${props.selectedAccount?.location}`,
      accounttype: getAccountCloudType(props.selectedAccount),
      address: `${props.selectedAccount?.address}`,
      city: `${props.selectedAccount?.city}`,
      state: `${props.selectedAccount?.state}`,
      zip: `${props.selectedAccount?.zip}`,
      country: `${props.selectedAccount?.country}`,
      phonenumber: `${props.selectedAccount?.phonenumber}`,
      phonenumberError: null,
      email: `${props.selectedAccount?.email}`,
      currentStepError: false,
      //Convert user selection of resource groups (array of objects) to array of strings
      accountResourceGroups:
        this.props.selectedAccount?.accountResourceGroups.map(
          (rg) => rg.resourcename
        ),
      selectedOption: this.props.selectedAccount?.accountResourceGroups.map(
        (rg) => {
          return { value: rg.resourcename, label: rg.resourcename };
        }
      ),
      defaultOptions: [
        { value: "H.R.", label: "H.R." },
        { value: "Finance", label: "Finance" },
        { value: "Engineering", label: "Engineering" },
        { value: "Unassigned", label: "Unassigned" },
      ],
      roleName: `${props.selectedAccount?.iamrole}`,
      externalId: `${props.selectedAccount}`
        ? `${props.selectedAccount.externalId}`
        : "",

      updateAccountError: false, // to display Snackbar
    };
    this.linkTextAreaRef = React.createRef();
  }

  closeAcctSuccesmsg = () => {
    this.props.updateData(this.props.accounts);
    this.props.closeModal();
    this.props.resetOrgAccountStatus();
    // this.props.clearAllOrgAccountMessages();
  };

  closeModal = () => {
    this.props.closeModal();
  };

  componentDidMount() {
    console.log("--=== componentDidMount in orgAccount", this.props);
    if (this.props.organizations === null || this.props.accounts === null) {
      console.log(
        "--=== componentDidMount, calling this.props.getListOfOrgsAndAccts()"
      );
      this.props.getListOfOrgsAndAccts();
    }
    if (this.props.aws === null) {
      console.log("--=== componentDidMount, calling this.props.getAwsAcc()");
      this.props.getAwsAcc();
    }
  }

  componentDidUpdate(prevProps) {
    console.log("~~~~~componentDidUpdate");

    if (
      this.props.postAccountConfigurationError &&
      this.props.postAccountConfigurationError !==
        prevProps.postAccountConfigurationError
    ) {
      this.setState({ updateAccountError: true });
      setTimeout(() => this.setState({ updateAccountError: false }), 5000);
    }
  }



  handleInputChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  handleMultiSelectChange = (selectedOption) => {
    //
    // Create list of resource groups selected for the account
    //
    if (selectedOption === null) {
      return;
    }
    this.setState(selectedOption);
    this.state.accountResourceGroups.splice(
      0,
      this.state.accountResourceGroups.length
    );

    selectedOption.map((rg) => {
      if (!this.state.accountResourceGroups.includes(rg.value)) {
        this.state.accountResourceGroups.push(rg.value);
      }
    });
    console.log(this.state.accountResourceGroups);
  };

  handleSelectChange = (selectedOption) => {
    if (selectedOption === null) {
      return;
    }
    this.setState(selectedOption);
    this.state.accountResourceGroups.length = 0;
    this.state.accountResourceGroups.push(selectedOption.value);
  };
  handleSubmit = () => {
    const resourceGroups = this.state.accountResourceGroups[0];

    let accountUpdateRequest = {
      accountNumber: this.state.accountNumber,
      address: this.state.address || "N/A",
      city: this.state.city || "N/A",
      country: this.state.country || "N/A",
      email: this.state.email || "N/A",
      phoneNumber: this.state.phonenumber || "N/A",
      zip: this.state.zip || "N/A",
      resourceGroup: resourceGroups,
      accountName: this.state.accountName,
    };

    console.log("accountUpdateRequest = ", accountUpdateRequest);

    //Call Saga for account update
    this.props.postAccountConfiguration(accountUpdateRequest);
  };

  isInvalid = () => {
    const cloudType = getAccountCloudType({
      accounttype: this.state.accounttype,
    });
    const isInvalidItems = [
      {
        field: "accountNumber",
        isInvalid: !this.state.accountNumber,
      },
      {
        field: "accountName",
        isInvalid: this.state.accountName.length === 0,
      },
      { field: "accountResourceGroups", isInvalid: false },
    ];
    // Account number format only matters for AWS (disabled field; keep parity with existing AWS checks)
    if (cloudType === "AWS") {
      isInvalidItems[0].isInvalid =
        this.state.accountNumber.length !== 12 ||
        !/^[0-9]+$/.test(this.state.accountNumber);
    }
    return isInvalidItems.filter((item) => item.isInvalid).length > 0;
  };

  handleCurrentStep = () => {
    if (this.state.accountNumber !== "" && this.state.accountName !== "") {
      this.setState({ currentStepError: false });
      return true;
    }
    this.setState({ currentStepError: true });
    return false;
  };



  render() {
    const cloudType = getAccountCloudType({
      accounttype: this.state.accounttype,
      accountType: this.state.accounttype,
    });
    const cloudLogo = cloudType === "AZURE" ? azureLogo : awsLogo;
    const cloudLogoAlt =
      cloudType === "AZURE" ? "Azure account type" : "AWS account type";
    const orgNameDisplay =
      this.state.orgName ||
      (this.props.organizations && this.props.organizations.length !== 0
        ? this.props.organizations[0].orgname
        : "");

    return (
      <React.Fragment>
        <div>
          <Container fluid={true}>
            <Row>
              <Col sm="12" md="12">
                <Card>
                  <CardBody>
                    <div id="basic-pills-wizard" className="twitter-bs-wizard">
                      <AvForm className="form-horizontal">
                        <div className="d-flex align-items-center mb-3">
                          <img
                            src={cloudLogo}
                            height="40"
                            alt={cloudLogoAlt}
                            style={{
                              marginRight: 10,
                              objectFit: "contain",
                            }}
                          />
                          <FormGroup className="mb-0 w-100">
                            <input
                              type="text"
                              name="orgName"
                              className="form-control"
                              value={orgNameDisplay}
                              disabled
                              readOnly
                              aria-label="Organization name"
                              style={{
                                backgroundColor: "#e9ecef",
                                color: "#6c757d",
                                cursor: "not-allowed",
                              }}
                            />
                          </FormGroup>
                        </div>
                        <Row>
                          <Col lg="12">
                            <FormGroup className="mb-3">
                              <AvField
                                name="accountNumber"
                                value={this.state.accountNumber}
                                placeholder={
                                  cloudType === "AZURE"
                                    ? "Subscription ID*"
                                    : "Account Number*"
                                }
                                type="text"
                                className={`form-control ${
                                  this.state.currentStepError &&
                                  this.state.accountNumber === ""
                                    ? "is-invalid-border"
                                    : null
                                }`}
                                onChange={this.handleInputChange}
                                errorMessage={
                                  cloudType === "AZURE"
                                    ? "Enter Subscription ID"
                                    : "Enter account number"
                                }
                                disabled
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg="12">
                            <FormGroup className="mb-3">
                              <AvField
                                name="accountName"
                                value={this.state.accountName}
                                placeholder="Account Name*"
                                type="text"
                                errorMessage="Enter account name"
                                className={`form-control ${
                                  this.state.currentStepError &&
                                  this.state.accountName === ""
                                    ? "is-invalid-border"
                                    : null
                                }`}
                                onChange={this.handleInputChange}
                                validate={{
                                  required: {
                                    value: true,
                                    errorMessage: "Account name is required",
                                  },
                                }}
                              />
                            </FormGroup>
                          </Col>
                        </Row>


                        <Row>
                          <Col lg="6">
                            <FormGroup className="mb-3">
                            <label htmlFor="resourcegroupfield">Resource Group</label>
                              <Creatable
                                name="rgs"
                                id='resourcegroupfield'
                                onChange={this.handleSelectChange}
                                formatCreateLabel={(inputValue) =>
                                  `Create ResourceGroup "${inputValue}"`
                                }
                                placeholder={"Select/create a resource group"}
                                defaultValue={this.state.selectedOption}
                                options={
                                  this.props.organizations &&
                                  this.props.organizations.length !== 0
                                    ? this.props.organizations[0].resourceGroups.map(
                                        (rg) => {
                                          return {
                                            value: rg.resourcename,
                                            label: rg.resourcename,
                                          };
                                        }
                                      )
                                    : null
                                }
                              />
                            </FormGroup>
                          </Col>
                        </Row>
                      </AvForm>
                    </div>

                    <Snackbar
                      open={this.state.updateAccountError}
                      autoHideDuration={5000}
                    >
                      <Alert severity="error">
                        Error while updating the account.{" "}
                        {typeof this.props.postAccountConfigurationError ===
                        "string"
                          ? this.props.postAccountConfigurationError
                          : this.props.postAccountConfigurationError?.message ||
                            ""}
                      </Alert>
                    </Snackbar>

                    <div
                      className="row"
                      style={{
                        marginTop: "30px",
                        gap: "10px",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <button
                        type="button"
                        className="btn w-lg btn-secondary"
                        onClick={this.closeModal}
                      >
                        Cancel
                      </button>
                      <button
                        className="btn w-lg btn-primary text-light"
                        disabled={
                          this.isInvalid() ||
                          this.props.isPostingAccountConfiguration
                        }
                        onClick={() => {
                          if (this.handleCurrentStep()) {
                            this.handleSubmit();
                          }
                        }}
                      >
                        {this.props.isPostingAccountConfiguration
                          ? "Loading ..."
                          : "Submit"}
                      </button>
                    </div>

                    <>
                      <Modal
                        isOpen={
                          this.props.postAccountConfigurationMessage !== null
                        }
                        centered
                      >
                        {console.log("Update Account Message ::", this.props.postAccountConfigurationMessage)}
                        <ModalBody>Account Sucessfully Updated</ModalBody>
                        <ModalFooter>
                          <Button onClick={this.closeAcctSuccesmsg}>
                            Close
                          </Button>
                        </ModalFooter>
                      </Modal>
                    </>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  const { accounts, organizations, reg_acct_error, account, loading, message } =
    state.orgAccount;
  const {
    pricingInfo,
    error: pricingInfoApiError,
    loading: pricingInfoApiLoading,
  } = state.pricingInfo;
  const {
    isReleaseDetailsGetting,
    getReleaseDetailsMessage,
    getReleaseDetailsError,
    releaseDetails,
  } = state.releaseNotes;

  const {
    isPostingAccountConfiguration,
    postAccountConfigurationMessage,
    postAccountConfigurationError,
  } = state.accountConfiguration;

  return {
    accounts,
    organizations,
    reg_acct_error,
    account,
    loading,
    message,
    pricingInfo,
    pricingInfoApiError,
    pricingInfoApiLoading,
    isReleaseDetailsGetting,
    getReleaseDetailsMessage,
    getReleaseDetailsError,
    releaseDetails,
    isPostingAccountConfiguration,
    postAccountConfigurationMessage,
    postAccountConfigurationError,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getListOfOrgsAndAccts: () => {
      dispatch(getListOfOrgsAndAccts());
    },
    updateOrgAccount: (data) => {
      dispatch(updateOrgAccount(data));
    },
    resetOrgAccountStatus: () => {
      dispatch(resetOrgAccountStatus(null));
    },
    getAwsAcc: () => {
      dispatch(getAwsAcc());
    },
    postAccountConfiguration: (accountConfigurationPayload) => {
      dispatch(postAccountConfiguration(accountConfigurationPayload));
    },
    clearAllAccountConfigurationMessages: () => {
      dispatch(clearAllAccountConfigurationMessages());
    },
  };
};

export default withStyles(styles)(
  connect(mapStatetoProps, mapDispatchToProps)(UpdateAccount)
);
